import { Record } from 'immutable'
import _ from 'lodash'

import { CHANGE_ENTITY_STACK_TAB, TOGGLE_ENTITY_STACK, OPEN_ENTITY_STACK } from './constants'

import { ENTITY_STACK_ADD_NOTIFICATION, ENTITY_STACK_REMOVE_NOTIFICATION } from '../../constants'

import { getCookie } from './helpers'

import config from '../../../../../../config'

const DEFAULT_TAB = _.get(config, 'components.entityStack.defaults.selectedTab')
const SEARCH = _.get(config, 'components.entityStack.search.key')

const initialState = Record({
    activeTab: getCookie('sessionMode') === 'permanent' ? SEARCH : DEFAULT_TAB,
    visibleEntityStack: true,
    notifications: {},
})

export default function (state = initialState(), action = {}) {
    switch (action.type) {
        case CHANGE_ENTITY_STACK_TAB: {
            const {
                data: { activeTab },
            } = action

            return state.set('activeTab', activeTab)
        }
        case ENTITY_STACK_ADD_NOTIFICATION: {
            const tabType = action?.data?.tabType
            const activeTab = state.get('activeTab')

            if (!tabType) return state

            if (tabType === activeTab) return state.setIn(['notifications', tabType], false)

            return state.setIn(['notifications', tabType], true)
        }
        case ENTITY_STACK_REMOVE_NOTIFICATION: {
            const tabType = action?.data?.tabType

            if (!tabType) return state

            return state.setIn(['notifications', tabType], false)
        }
        case TOGGLE_ENTITY_STACK: {
            const { visibleEntityStack } = state

            return state.set('visibleEntityStack', !visibleEntityStack)
        }
        case OPEN_ENTITY_STACK: {
            return state.set('visibleEntityStack', true)
        }

        default:
            return state
    }
}
